import { restoreEquipmentType } from '@/app/itemType/retireApi';
import { useBusyAction } from '@/db/useBusyAction';
import logger from '@/util/logger';
import type { EquipmentType } from '@rock/types';
import { toast } from 'sonner';

const log = logger('useRestoreEquipmentType');

/**
 * Bring a retired type back into the catalog, reopening the guide starters its retire dismissed. Anything
 * a retire moved onto its replacement stays there.
 */
export function useRestoreEquipmentType() {
    const { busy, run } = useBusyAction(log);

    return {
        busy,
        restoreEquipmentType: (type: EquipmentType) =>
            run('Restore', async () => {
                const { reopenedStarters } = await restoreEquipmentType({ typeId: type.id });
                toast.success(`Restored ${type.title}`, {
                    description: reopenedStarters
                        ? `Reopened ${reopenedStarters} guide starter${reopenedStarters === 1 ? '' : 's'}`
                        : undefined,
                });
                log.info('Restored equipment type', { typeId: type.id, reopenedStarters });
            }),
    };
}
